import React, { useEffect, useState } from "react";
import { DialogActions, DialogContent, DialogTitle, FormLabel } from "@mui/material";
import GridItem from "../../../components/Grid/GridItem";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import GridContainer from "../../../components/Grid/GridContainer";
import SaveButton from "../../../components/CustomInput/SaveButton";
import Subscription from "../../../licensing/Models/Subscription";
import { useDialog } from "../../../licensing/utils/DialogProvider";
import SubscriptionLine from "../../../licensing/Models/SubscriptionLine";
import ControlledSwitch from "../../../components/CustomInput/ControlledSwitch";
import * as actions from "../../../store/actions";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { addDays, format, getDate, getDaysInMonth } from "date-fns";
import { DatePicker } from "@mui/x-date-pickers";

function getFirstPossibleEndDate() {
  return addDays(new Date(), getDaysInMonth(new Date()) - getDate(new Date()));
}

function EndSubscription(props) {
  const firstPossibleEndDate = getFirstPossibleEndDate();
  const [endDate, setEndDate] = useState(firstPossibleEndDate);
  const [sendFinalInvoice, setSendFinalInvoice] = useState(false);
  const [finalInvoiceDate, setFinalInvoiceDate] = useState(null);
  const [saving, setSaving] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [subscription, setSubscription] = useState(null);
  const [subscriptionLine, setSubscriptionLine] = useState(null);
  const [, closeDialog] = useDialog();

  useEffect(() => {
    if (props.subscriptionId) {
      Subscription.get(props.subscriptionId).then(({ model }) => {
        setSubscription(model);
      });
    } else {
      SubscriptionLine.get(props.subscriptionLineId).then(({ model }) => {
        setSubscriptionLine(model);
      });
    }
  }, []);
  return (
    <>
      <DialogTitle>
        <TranslationWrapper tKey={"End License"} />
      </DialogTitle>
      <DialogContent style={{ minHeight: 400 }}>
        <GridContainer>
          <GridItem sm={4} xs={12}>
            <FormLabel>
              <TranslationWrapper tKey={"End license at date"} />
            </FormLabel>
          </GridItem>
          <GridItem sm={8} xs={12}>
            <DatePicker
              closeOnSelect
              minDate={firstPossibleEndDate}
              onChange={(date) => setEndDate(date)}
              value={endDate}
            />
          </GridItem>
          <GridItem sm={4} xs={12}>
            <FormLabel>
              <TranslationWrapper tKey={"Create final invoice?"} />
            </FormLabel>
          </GridItem>
          <GridItem sm={4} xs={12}>
            <ControlledSwitch
              checked={sendFinalInvoice}
              onHandleValue={(checked) => {
                setSendFinalInvoice(checked);
              }}
            />

            <DatePicker
              disabled={!sendFinalInvoice}
              nullable
              onChange={(date) => setFinalInvoiceDate(date)}
              value={finalInvoiceDate}
            />
          </GridItem>
        </GridContainer>
      </DialogContent>
      <DialogActions style={{ justifyContent: "center" }}>
        <SaveButton
          buttonText={<TranslationWrapper tDefault={"Opslaan"} tKey={"global.jamezzForm.savebutton.text"} />}
          disabled={subscription == null ? subscriptionLine == null : null}
          hasError={hasError}
          onClick={() => {
            setSaving(true);
            if (subscription) {
              subscription
                .apiEndSubscription(
                  format(endDate, "yyyy-MM-dd"),
                  sendFinalInvoice,
                  finalInvoiceDate ? format(finalInvoiceDate, "yyyy-MM-dd") : null
                )
                .then(() => {
                  toast.success("Ok");
                  closeDialog();
                })
                .catch((err) => {
                  toast.error(err.data.data.message);
                });
            }
            if (subscriptionLine) {
              subscriptionLine
                .apiEndSubscriptionLine(
                  format(endDate, "yyyy-MM-dd"),
                  sendFinalInvoice,
                  finalInvoiceDate ? format(finalInvoiceDate, "yyyy-MM-dd") : null
                )
                .then(() => {
                  toast.success("Ok");
                  closeDialog();
                })
                .catch((err) => {
                  toast.error(err.data.data.message);
                });
            }
          }}
          saving={saving}
          type={"submit"}
        />
      </DialogActions>
    </>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
  };
};

export default connect(null, mapDispatchToProps)(EndSubscription);
